import { Tooltip, withStyles } from "@material-ui/core";
import MuiTableCell from "@material-ui/core/TableCell";
import React from "react";
import styled from "styled-components";
import ActionsContextV2 from "../ActionsContextV2";

const Container = styled.div`
display:flex;
align-items:center;
justify-content:center;
cursor: pointer;
background-color:#ffdf5c
width:20px;
height:20px;
border-radius:10px;
`;

const SubContainer = styled.div`
  font-family: Roboto;
  font-size: 15px;
  font-weight: 500;
`;

const ActiveDeviationTableCell = withStyles({
  root: (props) => ({
    width: 20,
    padding: 0,
    paddingLeft: 15,
  }),
})(MuiTableCell);

const ActionOneTimeDeviationIcon = ({ action }) => {
  const { approvalType, approvalTypeColor } = action;
  const context = React.useContext(ActionsContextV2);

  let oneTimeDeviationCount = action.activeOneTimeDeviation ? 1 : 0;
  oneTimeDeviationCount += action.oneTimeDeviationHistory.length;

  if (oneTimeDeviationCount === 0) return <MuiTableCell />;

  let deviationTooltip =
    oneTimeDeviationCount > 1
      ? `${oneTimeDeviationCount} One-Time Deviations`
      : `${oneTimeDeviationCount} One-Time Deviation`;

  return (
    <ActiveDeviationTableCell>
      <Container
        style={{ backgroundColor: approvalTypeColor }}
        onMouseEnter={() => context.setHoverAction(action)}
        onMouseLeave={() => context.setHoverAction(null)}
      >
        <Tooltip title={deviationTooltip}>
          <SubContainer>!</SubContainer>
        </Tooltip>
      </Container>
    </ActiveDeviationTableCell>
  );
};

export default ActionOneTimeDeviationIcon;
